export const ESS_BEHAVIOUR_KEYS = {
  allowSelfEditEmail: 'essBehaviour.allowSelfEditEmail',
  allowSelfEditPhoneNumber: 'essBehaviour.allowSelfEditPhoneNumber'
} as const;

export const ROSTER_SETTINGS_KEYS = {
  allowEssWorkingPatterns: 'rosterSettings.allowEssWorkingPatterns',
  allowEssAvailabilityAdjustment: 'rosterSettings.allowEssAvailabilityAdjustment'
} as const;

export const OPTIMISER_SOLVER_KEYS = {
  enabledSolvers: 'optimiser.enabledSolvers',
  enableGeneticAlgorithm: 'optimiser.enableGeneticAlgorithm',
  enableCpSat: 'optimiser.enableCpSat',
  showEvaluation: 'optimiser.showEvaluation'
} as const;
